import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import threeEssentialsLogo from '@images/logos/3e-logo-vertical.svg'
import { t } from 'ember-intl'
import { UiButtonLink } from 'teacher-ui-client/components/ui-button/link'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

interface Signature {
  Args: {
    linkUrl: string
    linkText: string
  }
}

export const OneRosterNotice: TOC<Signature> = <template>
  <h2 class="py-4 text-xl font-medium text-neutral-300">{{t "manage.3essentials.pageTitle"}}</h2>
  <div class="flex flex-wrap items-stretch gap-6 xl:flex-nowrap">
    <OneRosterNoticeInformationTile @linkUrl={{@linkUrl}} @linkText={{@linkText}} />
    <div class="aspect-video w-108 shrink-0 shadow-xl">
      <iframe
        class="snappy:invisible h-full w-full rounded-sm object-cover"
        src="https://www.youtube.com/embed/_DeYtucXmrs"
        title={{t "manage.3essentials.videoTitle"}}
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      >
      </iframe>
    </div>
  </div>
</template>

export default OneRosterNotice

interface TileSignature {
  Args: {
    linkUrl: string
    linkText: string
  }
}

export const OneRosterNoticeInformationTile: TOC<TileSignature> = <template>
  <div data-test-notice-tile class="bg-gradient-3E rounded-lg p-0.5 shadow-xl">
    <div class="flex h-full gap-10 rounded-md bg-white p-6">
      <img
        class="max-w-[160px] shrink-0 xl:w-[160px]"
        src={{threeEssentialsLogo}}
        alt={{t "manage.3essentials.logoAlt"}}
      />
      <div class="flex shrink flex-col justify-between gap-4 text-neutral-300">
        <div class="space-y-4">
          <h2 class="text-xl font-medium">{{t "manage.3essentials.marketingTile.title"}}</h2>
          <div>{{t "manage.3essentials.marketingTile.blurb"}}
          </div>
        </div>
        <div class="flex items-center justify-between gap-4">
          <UiButtonLink
            class="inline-flex items-center gap-2 whitespace-nowrap"
            data-test-one-roster-manage-link
            href={{@linkUrl}}
            target="_blank"
            rel="noopener noreferrer"
            @appearance={{ButtonAppearance.regular}}
          >
            <span>{{@linkText}}</span>
            <PhosphorIcon @icon="phosphor-arrow-square-out-bold" />
          </UiButtonLink>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.3plearning.com/3essentials"
            class="inline-flex items-center gap-2 whitespace-nowrap"
          >
            <span>{{t "manage.3essentials.marketingTile.findOutMore"}}</span>
            <PhosphorIcon @icon="phosphor-arrow-square-out-bold" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
